import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { formatBallot } from '../fmt.js'
import { selectBallot, selectIsStateValid } from '../stores/store.js'

export function CopyBtnStateful() {
  const isStateValid = useSelector(selectIsStateValid)
  const ballot = useSelector(selectBallot)

  const disabled = !isStateValid
  const navigatorSupport = navigator?.clipboard?.writeText !== undefined

  const onClick = useCallback(async () => {
    if (disabled) return
    await navigator.clipboard.writeText(formatBallot(ballot))
  })

  const classList = [
    "text-white",
    "px-4",
    "py-2",
    "rounded",
    disabled ? "bg-green-300" : "bg-green-500",
    disabled ? "" : "hover:bg-green-600",
    disabled ? "cursor-not-allowed" : ""
  ]

  return !navigatorSupport ? null : <button className={classList.join(" ")} onClick={onClick}>
    Copier
  </button>
}